import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  useRef,
  useState,
  type KeyboardEventHandler,
  type ReactNode,
} from 'react';
import { Tooltip } from './Tooltip';

type Props = {
  children?: ReactNode;
  icon?: ReactNode;
};

export const HelperPopup = ({ children, icon }: Props) => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => setShow(true);
  const handleMouseLeave = () => setShow(false);
  const handleFocus = () => setShow(true);
  const handleBlur = () => setShow(false);
  const handleTouchEnd = () => setShow((prev) => !prev);
  const handleKeyDown: KeyboardEventHandler<HTMLButtonElement> = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setShow((prev) => !prev);
    }
    if (e.key === 'Escape') {
      setShow(false);
    }
  };

  return (
    <>
      <button
        type='button'
        aria-label='Help information'
        className='inline-flex items-center'
        ref={anchorRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onTouchEnd={handleTouchEnd}
        onKeyDown={handleKeyDown}
      >
        {icon ? (
          <span className='inline-block'>{icon}</span>
        ) : (
          <FontAwesomeIcon
            icon={faInfoCircle as IconProp}
            className='text-secondary'
          />
        )}
      </button>

      <Tooltip
        isVisible={show}
        anchorEl={anchorRef.current}
        placement='top'
        withArrow
        className='max-w-72 px-3 py-2 text-left'
      >
        {children}
      </Tooltip>
    </>
  );
};
